import NotFound from "../views/NotFound.vue";

// /** @type {import('vue-router').RouterOptions['routes']} */

export const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../layout/Layout.vue"),
    // redirect: "/session/signin",
    meta: {
      title: "Home",
    },
    children: [
      {
        path: "/",
        name: "Home",
        component: () => import("../views/Home.vue"),
        meta: {
          title: "Home",
          requiresAuth: true
        }
      },
    ],
  },
  {
    path: "/Account",
    name: "Account",
    component: () => import("../layout/EmptyLayout.vue"),
    meta: {
      title: "Account"
    },
    children: [
      {
        path: "/signin",
        name: "SignIn",
        component: () => import("../views/account/SignIn.vue"),
        meta: {
          title: "Agency",
          requiresAuth: false
        }
      },
      {
        path: "/register",
        name: "Register",
        component: () => import("../views/user/Register.vue"),
        meta: {
          title: "Agency",
          requiresAuth: false
        }
      },
    ],
  },
  {
    path: "/Settings",
    name: "Settings",
    component: () => import("../layout/Layout.vue"),
    meta: {
      title: "Settings",
    },
    children: [
      {
        path: "/Settings/Paye",
        name: "Paye",
        component: () => import("../views/paye/Paye.vue"),
        meta: {
          title: "Paye",
          requiresAuth: true
        }
      },
      {
        path: "/Settings/Major",
        name: "Major",
        component: () => import("../views/major/Major.vue"),
        meta: {
          title: "Major",
          requiresAuth: true
        }
      },
      {
        path: "/Settings/Major",
        name: "Major",
        component: () => import("../views/major/Major.vue"),
        meta: {
          title: "Major",
          requiresAuth: true
        }
      },
      {
        path: "/Settings/Settings",
        name: "Settings",
        component: () => import("../views/settings/Settings.vue"),
        meta: {
          title: "Settings",
          requiresAuth: true
        }
      },
      {
        path: "/Settings/SystemSettings",
        name: "SystemSettings",
        component: () => import("../views/settings/SystemSettings.vue"),
        meta: {
          title: "SystemSettings",
          requiresAuth: true
        }
      },
      {
        path: "/Settings/FinancialSetting",
        name: "FinancialSetting",
        component: () => import("../views/settings/FinancialSetting.vue"),
        meta: {
          title: "FinancialSetting",
          requiresAuth: true
        }
      },
      {
        path: "/Settings/Permissions",
        name: "Permissions",
        component: () => import("../views/settings/Permission.vue"),
        meta: {
          title: "Permissions",
          requiresAuth: true
        }
      },
      {
        path: "/Settings/SendNotifications",
        name: "SendNotifications",
        component: () => import("../views/settings/SendNotifications.vue"),
        meta: {
          title: "SendNotifications",
          requiresAuth: true
        }
      },
      {
        path: "/Settings/ManageSurveys",
        name: "manageSurvey",
        component: () => import("../views/manageSurvey/ManageSurvey.vue"),
        meta: {
          title: "ManageSurveys",
          requiresAuth: true
        }
      },
      {
        path: "/Settings/MonthlyPayments",
        name: "MonthlyPayments",
        component: () => import("../views/monthlyPayments/MonthlyPayments.vue"),
        meta: {
          title: "MonthlyPayments",
          requiresAuth: true
        }
      },
      {
        path: "/Settings/Levels",
        name: "Levels",
        component: () => import("../views/level/Level.vue"),
        meta: {
          title: "Levels",
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: "/Users",
    name: "Users",
    component: () => import("../layout/Layout.vue"),
    meta: {
      title: "Users",
    },
    children: [
      {
        path: "/Users/UserList",
        name: "userList",
        component: () => import("../views/user/User.vue"),
        meta: {
          title: "UserList",
          requiresAuth: true
        }
      },
      {
        path: "/Users/StudentList",
        name: "StudentList",
        component: () => import("../views/user/Student.vue"),
        meta: {
          title: "StudentList",
          requiresAuth: true
        }
      },
      {
        path: "/Users/TeacherList",
        name: "TeacherList",
        component: () => import("../views/user/Teacher.vue"),
        meta: {
          title: "TeacherList",
          requiresAuth: true
        }
      },
      {
        path: "/Users/EmployeeList",
        name: "EmployeeList",
        component: () => import("../views/user/Employee.vue"),
        meta: {
          title: "EmployeeList",
          requiresAuth: true
        }
      },
      {
        path: "/Users/UpdateUser",
        name: "UpdateUser",
        component: () => import("../views/user/UpdateUser.vue"),
        meta: {
          title: "UpdateUser",
          requiresAuth: true
        }
      },
      {
        path: "/Users/AccountCover",
        name: "AccountCover",
        component: () => import("../views/user/AccountCover.vue"),
        meta: {
          title: "AccountCover",
          requiresAuth: true
        }
      },
      {
        path: "/Users/ProfilePropaganda",
        name: "ProfilePropaganda",
        component: () => import("../views/user/ProfilePropaganda.vue"),
        meta: {
          title: "ProfilePropaganda",
          requiresAuth: true
        }
      },
      {
        path: "/Users/UserFinancial",
        name: "UserFinancial",
        component: () => import("../views/user/UserFinancial.vue"),
        meta: {
          title: "UserFinancial",
          requiresAuth: true
        }
      },
      {
        path: "/Users/UserCoursesLevel",
        name: "UserCourses",
        component: () => import("../views/user/UserCoursesLevel.vue"),
        meta: {
          title: "UserCourses",
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: "/Courses",
    name: "Courses",
    component: () => import("../layout/Layout.vue"),
    meta: {
      title: "Courses",
    },
    children: [
      {
        path: "/Courses/StandardCourseList",
        name: "standardCourseList",
        component: () => import("../views/course/StandardCourses.vue"),
        meta: {
          title: "StandardCourseList",
          requiresAuth: true
        }
      },
      {
        path: "/Courses/CourseList",
        name: "courseList",
        component: () => import("../views/course/Course.vue"),
        meta: {
          title: "UserList",
          requiresAuth: true
        }
      },
      {
        path: "/Courses/classroomList",
        name: "classroomList",
        component: () => import("../views/classroom/Classroom.vue"),
        meta: {
          title: "classroomList",
          requiresAuth: true
        }
      },
      {
        path: "/Courses/AbsenceList",
        name: "classroomAbsence",
        component: () => import("../views/classroom/ClassroomAbsence.vue"),
        meta: {
          title: "Classroom Absence",
          requiresAuth: true
        }
      },
      {
        path: "/Courses/ClassroomLeaves",
        name: "classroomLeaves",
        component: () => import("../views/classroomLeaves/ClassroomLeave.vue"),
        meta: {
          title: "classroom Leaves",
          requiresAuth: true
        }
      },
      {
        path: "/Courses/DiscussionStudies",
        name: "discussionStudies",
        component: () => import("../views/classroom/ClassroomStudy.vue"),
        meta: {
          title: "Discussion And Studies",
          requiresAuth: true
        }
      },
      {
        path: "/Courses/Survey",
        name: "survey",
        component: () => import("../views/manageSurvey/Survey.vue"),
        meta: {
          title: "Survey",
          requiresAuth: true
        }
      },
      {
        path: "/Courses/StudentAbsenceList",
        name: "studentAbsenceList",
        component: () => import("../views/classroom/StudentAbsenceList.vue"),
        meta: {
          title: "Survey",
          requiresAuth: true
        }
      },
      {
        path: "/Courses/Grades",
        name: "grades",
        component: () => import("../views/grade/Grades.vue"),
        meta: {
          title: "Grades",
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: "/Reports",
    name: "Reports",
    component: () => import("../layout/Layout.vue"),
    meta: {
      title: "Reports",
    },
    children: [
      {
        path: "/Reports/ReportSurveys",
        name: "reportSurveys",
        component: () => import("../views/manageSurvey/ReportSurveys.vue"),
        meta: {
          title: "Report Surveys",
          requiresAuth: true
        }
      },
      {
        path: "/Reports/ReportStudy",
        name: "reportStudy",
        component: () => import("../views/classroom/StudentStudyList.vue"),
        meta: {
          title: "Report Study",
          requiresAuth: true
        }
      },
      {
        path: "/Reports/ReportTeacherAbsence",
        name: "reportTeacherAbsence",
        component: () => import("../views/classroom/TeacherAbsenceList.vue"),
        meta: {
          title: "Report Teacher Absence",
          requiresAuth: true
        }
      },
      {
        path: "/Reports/GradeReport",
        name: "gradeReport",
        component: () => import("../views/grade/GradeReport.vue"),
        meta: {
          title: "Grade Report",
          requiresAuth: true
        }
      },
      {
        path: "/Reports/reportCardService",
        name: "reportCards",
        component: () => import("../views/reportCard/ReportCards.vue"),
        meta: {
          title: "Report Cards",
          requiresAuth: true
        }
      },
      {
        path: "/Reports/reportSurveysDetail",
        name: "reportSurveysDetail",
        component: () => import("../views/manageSurvey/ReportSurveysDetail.vue"),
        meta: {
          title: "Report Surveys Detail",
          requiresAuth: true
        }
      },
    ]
  },

  {
    path: "/EvaluationActions",
    name: "EvaluationActions",
    component: () => import("../layout/Layout.vue"),
    meta: {
      title: "EvaluationActions",
    },
    children: [{
      path: "/EvaluationActions/Actions",
      name: "actions",
      component: () => import("../views/evaluationActions/EvaluationActions.vue"),
      meta: {
        title: "actions",
        requiresAuth: true
      }
    },
      {
        path: "/EvaluationActions/ActionGrade",
        name: "actionGrade",
        component: () => import("../views/evaluationActions/ActionGrade.vue"),
        meta: {
          title: "actionGrade",
          requiresAuth: true
        }
      }]
  },
  {
    path: "/ML",
    name: "ML",
    component: () => import("../layout/Layout.vue"),
    meta: {
      title: "ML",
    },
    children: [{
      path: "/ML/ConceptualSearch",
      name: "ConceptualSearch",
      component: () => import("../views/ml/SearchPage.vue"),
      meta: {
        title: "ConceptualSearch",
        requiresAuth: true
      }
    }]
  },

  {
    path: "/ML",
    name: "ML",
    component: () => import("../layout/Layout.vue"),
    meta: {
      title: "ML",
    },
    children: [{
      path: "/ML/ConceptualSearch",
      name: "actions",
      component: () => import("../views/ml/SearchPage.vue"),
      meta: {
        title: "actions",
        requiresAuth: true
      }
    }]
  },
  {
    path: "/Books",
    name: "Book",
    component: () => import("../layout/Layout.vue"),
    meta: {
      title: "ML",
    },
    children: [{
        path: "/Books/Book/:bookNumber/:volumeNumber/:pageNumber",
        name: "BookReader",
        component: () => import("../views/books/BookReader.vue"),
        meta: {
          title: "Book Reader",
          requiresAuth: true,
        },
        props: true,  // این باعث میشه پارامترها به عنوان props دریافت بشن
      }]
  },
  {
    path: "/Notebook",
    name: "Notebook",
    component: () => import("../layout/Layout.vue"),
    meta: {
      title: "Notebook",
    },
    children: [{
      path: "/Notebook",
      name: "NotebookView",
      component: () => import("../views/notebook/NoteBookView.vue"),
      meta: {
        title: "دفترچه یادداشت",
        requiresAuth: true,
      },
    }],
  },
  {path: "/:path(.*)", component: NotFound},
];
